type DividerMarginTop = "0" | "1" | "2" | "3" | "4" | "5";

export type DividerProps = {
    className?: string;
    marginTop?: DividerMarginTop;
};

const DividerMarginVariants: Record<DividerMarginTop, string> = {
    "0": "tw:mt-0",
    "1": "tw:mt-1",
    "2": "tw:mt-2",
    "3": "tw:mt-3",
    "4": "tw:mt-4",
    "5": "tw:mt-5"
};

const Divider = ({ className = "", marginTop = "3" }: DividerProps) => (
    <span
        className={`tw:block tw:w-full tw:border-b tw:border-b-divider ${DividerMarginVariants[marginTop]} ${className}`}
    />
);

export { Divider };
